import apiService from '../apiService';

export const addTagTypes = ['Cards_List'] as const;

export const applicationsApi = apiService
	.enhanceEndpoints({
		addTagTypes
	})
	.injectEndpoints({
		endpoints: (build) => ({
			getCardsList: build.query({
				query: ({ starting_after }: { starting_after?: string | null } = {}) => ({
					url: 'payment-method',
					params: {
						per_page: 10,
						...(starting_after ? { starting_after } : {})
					}
				}),
				providesTags: ['Cards_List']
			}),
			attachedNewCard: build.mutation({
				query: ({ paymentMethodId, setAsDefault = true }) => ({
					url: 'payment-method/attach',
					method: 'POST',
					body: {
						payment_method_id: paymentMethodId,
						set_as_default: setAsDefault
					}
				}),
				invalidatesTags: ['Cards_List']
			}),
			setDefaultCard: build.mutation({
				query: ({ paymentMethodId }) => ({
					url: 'payment-method/set-default',
					method: 'POST',
					body: {
						payment_method_id: paymentMethodId
					}
				}),
				invalidatesTags: ['Cards_List']
			}),
			deleteCard: build.mutation({
				query: ({ paymentMethodId }) => ({
					url: `payment-method/detach/${paymentMethodId}`,
					method: 'DELETE'
				}),
				invalidatesTags: ['Cards_List']
			})
		})
	});

export const { useGetCardsListQuery, useAttachedNewCardMutation, useSetDefaultCardMutation, useDeleteCardMutation } =
	applicationsApi;
